import request from '#api/axios';
import { queryKeyFactory } from '#api/queryKeyFactory';
import { HEALTH_INFO_TYPE } from '#pages/Community-refactor/write/constant';
import { IGetPainPartKinds } from '#types/painPartKinds';
import { UseQueryOptions, useQuery } from '@tanstack/react-query';
import { AxiosError } from 'axios';

export const getPainPartKinds = async () => {
  const res = await request<IGetPainPartKinds>({
    method: 'get',
    url: '/pain-part-kinds',
    params: {
      page: 0,
      offset: 100
    }
  });

  return res.data;
};

export const useGetPainPartKinds = (
  healthInfo: HEALTH_INFO_TYPE,
  options?: UseQueryOptions<
    IGetPainPartKinds,
    AxiosError,
    IGetPainPartKinds,
    string[]
  >
) => {
  return useQuery(queryKeyFactory.GET_PAIN_PART_KINDS(), getPainPartKinds, {
    enabled: healthInfo === '수술 이력 / 통증',
    ...options
  });
};
